import { css } from "@emotion/react"

export const navBar = (theme) => css`
  position: relative;
  flex-wrap: nowrap;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0px 2px 5px 0px ${theme.colors.border.primary};
  padding: 0.5rem 1rem;
  z-index: ${theme.zIndex.z5};

  & > .MuiGrid-item {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`

export const menuButton = (theme) => css`
  color: ${theme.colors.font.primary};
`

export const brand = css`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
`

export const userOption = (theme) => css`
  text-decoration: none;
  text-transform: none;
  color: ${theme.colors.font.primary};
  font-weight: bold;
  margin-right: 0.5rem;
  padding-left: 1rem;
  padding-right: 1rem;

  & > svg {
    margin-left: 0.5rem;
    color: ${theme.colors.font.variants.lighter1};
  }
`
